<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-09 14:33:11
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-05 17:19:43
-->
<template>
  <div class="box">
    <a-spin :spinning="loading">
      <a-table
        v-if="columns && isSelectRow"
        :columns="columns"
        :data-source="dataSource"
        :row-key="(record) => record.id"
        :pagination="false"
        class="table"
        :bordered="bordered"
        :scroll="{ x:'max-content',y: y }"
        :row-selection="rowSelection"
        :rowKey="`${sortId}`"
        :locale="locale"
      >
        <template
          v-for="(item, index) in customSlot"
          :slot="item.customRender"
          slot-scope="text, record"
        >
          <slot :scope="record" :name="item.name"></slot>
        </template>
        <template slot="action" slot-scope="text, record">
          <slot :scope="record" name="operation"></slot>
        </template>
      </a-table>
      <a-table
        v-if="columns && !isSelectRow"
        :columns="columns"
        :data-source="dataSource"
        :row-key="(record,index) => record.id||record.mediaId||index"
        :pagination="false"
        :bordered="bordered"
        class="table"
        :scroll="{ x:'max-content',y: y }"
        :locale="locale"
      >
        <template
          v-for="(item, index) in customSlot"
          :slot="item.customRender"
          slot-scope="text, record"
        >
          <slot :scope="record" :name="item.name"></slot>
        </template>
        <template slot="action" slot-scope="text, record">
          <slot :scope="record" name="operation"></slot>
        </template>
      </a-table>
    </a-spin>
    <div class="pagination" v-if="pagination.total > 0">
      <a-pagination
        :current="pagination.current"
        :pageSize="pagination.pageSize"
        show-size-changer
        show-quick-jumper
        :total="pagination.total"
        @change="onShowSizeChange"
        @showSizeChange="handleSizeChange"
        :page-size-options="pagination.pageSizeOptions"
        :show-total="(total) => `共 ${pagination.total} 条`"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      height: 380,
      locale:{emptyText:<el-empty description="暂无数据"></el-empty>},
    };
  },
  props: {
    columns: {
      type: Array,
      default: () => {
        return [];
      },
    },
    dataSource: {
      type: Array,
      default: () => {
        return [];
      },
    },
    pagination: {
      default: () => {
        return {};
      },
    },
    y: {
      type: Number,
      default: 0,
    },
    x:{
      type: Number,
      default: 0,
    },
    customSlot: {
      type: Array,
      default: () => {
        return [];
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isSelectRow: {
      type: Boolean,
      default: false,
    },
    rowKeys: {
      type: Array,
      default: () => {
        return [];
      },
    },
    sortId: {
      type: String,
      default: "id",
    },
    bordered:{
      type: Boolean,
      default: false,
    },
    disRow:{
       type: String,
      default: "importState",
    },
    disState:{
      type:Array,
      default:()=>{
        return [1]
      },
    }
  },
  mounted() {
    // if (this.pagination) {
    //   if (
    //     document.getElementsByClassName(
    //       "ant-pagination-options-quick-jumper"
    //     )[0]
    //   ) {
    //     document.getElementsByClassName(
    //       "ant-pagination-options-quick-jumper"
    //     )[0].childNodes[0].nodeValue = "前往";
    //   }
    //   console.log(this.y, "ssssssssss");
    // }
  },
  watch:{
    y(val){
      console.log(val)
    }
  },
  methods: {
    onShowSizeChange(current) {
      this.pagination.current = current;
      this.$emit("onShowSizeChange", current);
    },
    handleSizeChange(current, pageSize) {
      this.$emit("handleSizeChange", pageSize);
    },
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.rowKeys,
        fixed:true,
        columnWidth:'48px',
        getCheckboxProps: (record) => {
          return {
            props: {
              disabled:this.disState.indexOf(record[this.disRow]) != -1?true:false, // 禁选项
            },
          };
        },
        onChange: (selectedRowKeys, selectedRows) => {
          this.$emit("selectedRowKeys", selectedRowKeys, selectedRows);
        },
      };
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  width: 100%;
}
.table {
  margin: 24px;
}
/deep/ .ant-pagination-options {
  float: left;
  margin-right: 58px;
}
/deep/ .ant-pagination-total-text {
  float: left;
}
/deep/ .ant-pagination-options-quick-jumper {
  position: absolute;
  right: 20px;
}
/deep/ .ant-pagination {
  margin-right: 124px;
}
.pagination {
  display: flex;
  padding: 12px;
  padding-right: 0px;
  justify-content: right;
  border-top: solid #E4E7ED 1px;
  position: absolute;
  bottom: 0;
  width: 100%;
  padding-right: 24px;
}
.goto {
  display: flex;
  align-items: center;
  margin-left: 56px;
}
/deep/ .ant-table {
  border: solid 1px #f1f1f1;
  border-bottom: none;
  border-radius: 5px;
  color: rgba(255, 255, 255, 1);
}
/deep/ .ant-pagination-item-active {
  background: #1890ff;
}
/deep/ .ant-pagination-item-active a {
  color: #fff;
}
/deep/ .ant-table-column-title {
  color: #000;
  font-size: 14px;
  font-weight: 600;
}
.btn {
  margin-right: 14px;
}

/deep/ .ant-table-tbody > tr > td{
    padding: 9.5px 16px;
    color: #303133;
}
/deep/ .ant-table-thead > tr > th{
   padding: 12.5px 16px;
}
/deep/ .ant-table-fixed-left{
  border-right: 1px solid rgba(228, 231, 237, 1);
}
/deep/ .ant-table-fixed-right{
    border-left: 1px solid rgba(228, 231, 237, 1);
    
}
/deep/ .ant-table-fixed-right .ant-table-tbody > tr > td{
   padding: 9.5px 24px;
}
/deep/ .ant-table-fixed-right .ant-table-thead > tr:first-child > th:last-child{
  padding: 12.5px 24px;
  
}
/deep/ .ant-table-thead > tr > th{
    background-color: rgba(245, 247, 250, 1);
}
/deep/ .ant-table-thead > tr{
   background-color: rgba(245, 247, 250, 1);
}
/deep/ .ant-table-hide-scrollbar{
  background-color: rgba(245, 247, 250, 1);
  
}
/deep/ .ant-table-column-title{
    color: #606266;
}
/deep/ .ant-table{
  border: solid 1px #E4E7ED;
}
/deep/ .ant-table-fixed-left table,.ant-table-fixed-right table{
    width: min-content;
    }
    /deep/ .ant-table-row-cell-ellipsis {
      max-width: 1px !important;
      overflow: hidden !important;
      white-space: nowrap !important;
      -o-text-overflow: ellipsis !important;
      text-overflow: ellipsis !important;
  }

  /deep/ .el-empty__description p{
    color: rgba(16, 16, 16, 1);
    font-size: 16px;
    text-align: left;
    font-family: Roboto-regular;
  }
  /deep/ .el-empty{
    padding: 11px 0px 15px 0px;
  }
  /deep/ .el-empty__description{
    margin-top: 10px;
  }
  /deep/ .ant-table-placeholder{
    border-bottom: none;
  }

   /deep/ tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td, .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td, .ant-table-thead > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td, .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
    background:#fafafa !important;
  }
  /deep/ tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td{
    background:#fafafa !important;
  }
  
</style>